module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "section005"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/title_page",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "centered_text"
  }, [_c('p', [_c('span', {
    attrs: {
      "href": "#/text/Part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  })]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("When I Cannot Sleep—Day Six—a Letter")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("To Be a God")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("My Mother Takes the Stand")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("On the Mysterious Disappearance of Fortunetellers")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Self-Portrait in Which I Resemble the Man next to Me")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nobody")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Jukebox That Ended the World Twice")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proxy Baptism")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Opera Singer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "centered_text"
  }, [_c('p', [_c('span', {
    attrs: {
      "href": "#/text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  })]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Banquet")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Mistake")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Illness")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Idiom of the Entrepreneur")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Then After")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Election Day")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Two Surgeons")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Diner")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Player Piano")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("When the Buskers Leave Town for Good")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Kind of Life I Always Wanted")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Door")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "centered_text"
  }, [_c('p', [_c('span', {
    attrs: {
      "href": "#/text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  })]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Field Kabuki")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Game")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Very Very Important Benefactor")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Story as It Was Told to Me")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Portrait of What Is Not There")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Habeas Corpus")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nobody")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("How I Came to Rule the World")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("As You Left It")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c620f38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Toc.vue
// module id = 75
// module chunks = 0